import React, { lazy, Suspense, useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import htmlParser from 'html-react-parser';
import { formatInTimeZone } from 'date-fns-tz';
import { StyledModal } from "../VideoSection/styles";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu";
import "../Body/Body.css";

const Form = lazy(() => import("../../components/SignUpForm/SignUpForm"));
const Video = lazy(() => import("../VideoSection/video"));

export default function Body({ bannerData, timerData, formData, isMobile }) {

    const imgCDNURL = process.env.REACT_APP_MORGANUNIVERSITY_CDN_URL;
    const [isTimerUp, setIsTimerUp] = useState(false);
    const [isTimerUpnew, setIsTimerUpnew] = useState(false);
    const [play, setPlay] = useState(false);
    const [url, setUrl] = useState("");

    const videoToggle = (play, url) => {
        setPlay(!play);
        setUrl(url);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            let time = new Date();
            let currentzone = formatInTimeZone(time, 'America/New_York', 'yyyy-MM-dd HH:mm:ss');
            let now = new Date(currentzone).getTime();
            const targetdate = new Date(timerData.webinardatetime).getTime();
            const targetdate1 = new Date(timerData.webinarenddatetime).getTime();
            const distance1 = targetdate1 - now;
            const distance = targetdate - now;
            // console.log(distance);

            // console.log(distance1);

            if (distance1 <= 0) {
                clearInterval(interval);
                setIsTimerUpnew(true);
            } else {

            };

            if (distance <= 0) {
                clearInterval(interval);
                setIsTimerUp(true);
            } else {

            }


        });

        return () => clearInterval(interval);
    }, [timerData]);
    return (
        <>
            <div className="banner">
                {isMobile && (
                    <UserWayAccessibilityMenu color="white" width={40} height={40}  />
                )}
                <Container >
                    <Row>
                        <Col>
                            <div className="bannertext">
                                <p>{htmlParser(bannerData.lionbannertext)}</p>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="dottedbox">

                                {isTimerUp ?
                                    (
                                        <>
                                            {isTimerUpnew ?
                                                (
                                                    <p className="phasethree">{htmlParser(bannerData.phase3line)}</p>
                                                ) : (
                                                    <div>
                                                        <p className="phasetwo">{htmlParser(bannerData.phase2line)}</p>
                                                        <p className="previoustwo">{htmlParser(bannerData.previousWebinar)}</p>
                                                    </div>
                                                )
                                            }
                                        </>

                                    ) : (
                                        <div className="howtojoin">
                                            <p className="phone">
                                                <a href="tel:+18334786937" style={{ color: '#fff' }}>
                                                    (833) 478-6937
                                                </a>
                                            </p>

                                            <p className="joincontent">Únete de manera anónima el {htmlParser(bannerData.date)} a las {htmlParser(bannerData.time)} <br />¡Visita <a href="https://www.angelai.ai" target="_blank">AngelAi.Ai</a> e informa que<br />
                                                quieres "Unirte Ahora"!</p>
                                            <p className="previous">{htmlParser(bannerData.previousWebinar)}</p>

                                        </div>
                                    )
                                }
                            </div>
                        </Col>

                    </Row>
                </Container>
            </div>
            <div>
                <Container>
                    <Row>
                        <Col xl={7} lg={7}>
                            <div className="yellowgrad1" />
                            <div className="yellowgrad2" />

                            <img src={imgCDNURL + (bannerData.lionvideoimage)}
                                alt="AngelAi video"
                                onClick={() =>
                                    videoToggle(
                                        play, (bannerData.lionyoutubevideo)
                                    )
                                }
                                className="lionvideo"
                                loading="lazy"

                            />

                        </Col>
                        <Col xl={5} lg={5}>
                            <Suspense fallback={<div />}>
                                <Form formData={formData} />
                            </Suspense>
                        </Col>
                    </Row>
                </Container>
            </div>
            <Suspense fallback={<div />}>
                <StyledModal show={play}>
                    <Video onClose={() => videoToggle(play, '')} url={url} />
                </StyledModal>
            </Suspense>
        </>

    );
}
